module.exports = __webpack_public_path__ + "static/img/newFood13.7e51599.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newFood13.png
// module id = llpB
// module chunks = 2